import { styled } from '@linaria/react';
import { Form } from 'react-hook-form';

export const FormStyled = styled(Form)`
	display: flex;
	overflow: hidden;
	height: 100%;
	min-height: 0;
	flex-direction: column;
	gap: 16px;
`;

export const Options = styled.div`
	display: flex;
	min-height: 0;
	flex: 1;
	flex-direction: column;

	padding-right: 4px;
	gap: 8px;

	-webkit-overflow-scrolling: touch;
	overflow-y: auto;
	scrollbar-width: thin;
`;

export const FixedSection = styled.div`
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
	gap: 16px;
`;

export const InputSection = styled.div`
	flex-shrink: 0;
`;

export const ButtonSection = styled.div`
	width: 240px;
	flex-shrink: 0;
	align-self: center;
`;
